"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesField = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const fdr_travel_dates_styles_1 = require("./fdr-travel-dates.styles");
function FdrTravelDatesField({ disabled = false, isDropdownOpened, translatedShortInformation, textInputRef, onClick, customLabel, children, onKeyPress, className, }) {
    const [t] = (0, next_i18next_1.useTranslation)('search');
    if (disabled)
        return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesInput, { readOnly: true, icon: { name: 'calendar' }, value: translatedShortInformation }));
    return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesInputWrapper, null,
        react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesInput, { readOnly: true, hideLabel: true, inputRef: textInputRef, name: "travelDates", "data-id": "travelDatesResultsInput", icon: { name: 'calendar' }, label: t('dates.label'), value: translatedShortInformation, customLabel: customLabel, onClick: onClick, onKeyPress: onKeyPress, className: `${className ? className : 'travelDatesInput'} ${isDropdownOpened ? 'open' : ''}` }),
        children));
}
exports.FdrTravelDatesField = FdrTravelDatesField;
//# sourceMappingURL=fdr-travel-dates-field.js.map